import { object, string } from 'yup';

import * as constants from '@/constants';
import i18n from '@/settings/i18n';

export const adminSchema = object({
  firstName: string()
    .max(
      constants.NAME_LENGTH,
      i18n.t('ui.error.maxlength', { length: constants.NAME_LENGTH }),
    )
    .matches(constants.KANA_KANJI_PATTERN, i18n.t('ui.error.format'))
    .trim()
    .required(i18n.t('ui.error.required.input')),
  lastName: string()
    .max(
      constants.NAME_LENGTH,
      i18n.t('ui.error.maxlength', { length: constants.NAME_LENGTH }),
    )
    .matches(constants.KANA_KANJI_PATTERN, i18n.t('ui.error.format'))
    .trim()
    .required(i18n.t('ui.error.required.input')),
  kanaFirstName: string()
    .max(
      constants.NAME_LENGTH,
      i18n.t('ui.error.maxlength', { length: constants.NAME_LENGTH }),
    )
    .matches(constants.KANA_PATTERN, i18n.t('ui.error.format'))
    .trim()
    .required(i18n.t('ui.error.required.input')),
  kanaLastName: string()
    .max(
      constants.NAME_LENGTH,
      i18n.t('ui.error.maxlength', { length: constants.NAME_LENGTH }),
    )
    .matches(constants.KANA_PATTERN, i18n.t('ui.error.format'))
    .trim()
    .required(i18n.t('ui.error.required.input')),
}).required();
